import { QrCode } from '../../../components'
import { MfaSetup } from '../core/_models'

type MfaSetupInstructionsProps = {
  setup: MfaSetup
  layout?: 'empilhado' | 'lado-a-lado'
  className?: string
}

/**
 * Passo a passo do cadastro do autenticador, compartilhado entre a tela de login e o card do
 * perfil. O layout `empilhado` centraliza o QR Code sobre a chave, como na tela de login; o
 * `lado-a-lado` mantém QR Code e chave na mesma linha, como no card do perfil.
 */
export const MfaSetupInstructions = ({
  setup,
  layout = 'empilhado',
  className = '',
}: MfaSetupInstructionsProps) => {
  const empilhado = layout === 'empilhado'

  return (
    <div className={className}>
      <ol className='ps-4 text-gray-700 mb-5'>
        <li className='mb-2'>
          Instale um aplicativo autenticador, como Google Authenticator ou Authy.
        </li>
        <li className='mb-2'>
          {empilhado
            ? 'Leia o QR Code abaixo ou digite a chave manualmente.'
            : 'Leia o QR Code ou digite a chave manualmente.'}
        </li>
        <li>Informe o código de 6 dígitos que o aplicativo exibir.</li>
      </ol>

      <div
        className={`d-flex flex-wrap gap-5 ${
          empilhado ? 'flex-column align-items-center' : 'align-items-center'
        }`}
      >
        <div className='bg-white p-4 rounded border'>
          <QrCode url={setup.otpauthUri} />
        </div>
        <div className={empilhado ? 'w-100' : 'flex-grow-1'}>
          <div className='text-gray-700 fw-semibold mb-2'>
            {empilhado
              ? 'Não consegue ler o QR Code? Use esta chave:'
              : 'Chave para digitação manual:'}
          </div>
          <code
            className={`d-block bg-light rounded py-3 px-4 fs-5 text-dark text-break ${
              empilhado ? 'text-center' : ''
            }`}
          >
            {setup.segredo}
          </code>
        </div>
      </div>
    </div>
  )
}
